<fidelity-overlay-page-wrapper
    *transloco="let t; prefix 'fidelity-app'"
    [headerCaption]="t('account.delete.heading')"
>
    <div
        pageContent
        *transloco="let gt"
        class="flex flex-col p-4"
    >
        <h2 class="mb-2">{{ t('account.delete.title') }}</h2>
        <p class="mb-2">{{ t('account.delete.description') }}</p>

        <button
            class="fuse-mat-button-large mt-6 w-full"
            color="warn"
            mat-flat-button
            [disabled]="disableCrudActions()"
            (click)="deletePersonalData()"
        >
            @if (!disableCrudActions()) {
                <span>
                        {{ gt('generic.delete') }}
                    </span>
            } @else {
                <mat-progress-spinner
                    [diameter]="24"
                    [mode]="'indeterminate'"
                ></mat-progress-spinner>
            }
        </button>
    </div>
</fidelity-overlay-page-wrapper>
